/** "€1.23M", "€420k", "€42" — matches the style of the prior HTML dashboard. */
export function eurShort(v: number): string {
  if (v >= 1_000_000) return '€' + (v / 1_000_000).toFixed(2) + 'M';
  if (v >= 1_000) return '€' + (v / 1_000).toFixed(0) + 'k';
  return '€' + Math.round(v).toLocaleString('en-US');
}

export function eurFull(v: number): string {
  return '€' + Math.round(v).toLocaleString('en-US');
}

const STAGE_LABEL: Record<string, string> = {
  prospecting: 'Prospecting',
  discovery: 'Discovery',
  qualification: 'Qualification',
  considering: 'Considering',
  proposal: 'Proposal',
  proposal_out: 'Proposal Out',
  negotiation: 'Negotiation',
  handshake: 'Handshake',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
  unknown: 'Unknown stage',
};

// Order matches the Attio Deals pipeline left-to-right.
export const OPEN_STAGES_ORDERED = [
  'prospecting',
  'discovery',
  'considering',
  'proposal_out',
  'negotiation',
  'handshake',
] as const;

export type OpenStage = (typeof OPEN_STAGES_ORDERED)[number];

// "Active pipeline" mirrors the Attio view of the same name: deals that have
// moved past the very first touch but aren't yet handshake'd or closed.
export const ACTIVE_PIPELINE_STAGES: readonly OpenStage[] = [
  'discovery',
  'considering',
  'proposal_out',
  'negotiation',
];

export function formatStage(stage: string): string {
  return STAGE_LABEL[stage] ?? stage;
}

/** "1 deal", "3 deals" — a count with its noun, singular when it should be. */
export function plural(n: number, noun: string, pluralNoun = `${noun}s`): string {
  return `${n.toLocaleString('en-GB')} ${n === 1 ? noun : pluralNoun}`;
}
